import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = {
  key: 0,
  class: "flex justify-end"
}
const _hoisted_3 = { class: "flex justify-center w-full md:w-auto mt-2 md:mt-0" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["src"]

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import { useThemeStore } from '@/stores/useThemeStore';
import { useScreenSize } from '@/composables/useScreenSize';
import { LANGUAGES } from '@/constants/translation';
import { Translation } from '@/plugins/Translation';
import IconClose from '@/components/icons/IconClose';


export default /*#__PURE__*/_defineComponent({
  __name: 'LanguageSwitcher',
  setup(__props) {

const { locale } = useI18n();
const route = useRoute();
const router = useRouter();
const { isMobile } = useScreenSize();
const themeStore = useThemeStore();
const {
  isShowNavigationMenu,
  isShowLanguageMenu,
} = storeToRefs(themeStore);

const languageMenu = computed(() => {
  return LANGUAGES.slice().map((item) => {
    return {
      label: item.abbr,
      iso: item.iso,
    };
  });
});

function toggleMenu () {
  if (!isShowLanguageMenu.value && isShowNavigationMenu.value) {
    themeStore.closeNavigationMenu();
  }
  themeStore.toggleShowLanguageMenu();
}
function closeMenu () {
  themeStore.closeLanguageMenu();
}
function changeLanguage (langIso: string) {
  locale.value = langIso;
  router.replace(Translation.i18nRoute({
    // name: route.name
  }));
  Translation.changeLanguage(langIso);
  closeMenu();
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      class: "block md:hidden px-5",
      onClick: toggleMenu
    }, [
      _createElementVNode("img", {
        src: require(`@/assets/${_unref(locale)}.png`),
        class: "w-6 h-6 md:w-[34px] md:h-auto object-cover md:object-none rounded-full"
      }, null, 8, _hoisted_1)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass([
        'absolute top-[63px] left-0 right-0 md:static w-full md:w-auto',
        'px-4 pb-5 md:p-0 border-y border-mcgard-gray-300 md:border-0',
        'bg-mcgard-gray-200 md:bg-transparent',
        _unref(isShowLanguageMenu) || !_unref(isMobile) ? 'translate-y-0 z-[1]' : '-translate-y-full z-[-1]',
        _unref(isMobile) ? 'transition-all duration-200' : null,
      ])
    }, [
      (_unref(isMobile))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("button", {
              class: "py-2 px-4",
              onClick: closeMenu
            }, [
              _createVNode(_unref(IconClose))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(languageMenu), (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: `langSwitcher${index}`,
            class: "px-2"
          }, [
            _createElementVNode("button", {
              class: "flex flex-col items-center cursor-pointer group",
              onClick: ($event: any) => (changeLanguage(item.iso))
            }, [
              _createElementVNode("img", {
                src: require(`@/assets/${item.iso}.png`),
                class: _normalizeClass([
                'w-[34px]',
                _unref(locale) === item.iso ? null : 'grayscale group-hover:grayscale-0'
              ])
              }, null, 10, _hoisted_5),
              _createElementVNode("span", {
                class: _normalizeClass([
                'hidden md:block mt-1 uppercase text-[11px]',
                'group-hover:text-mcgard-primary',
                _unref(locale) === item.iso ? 'text-mcgard-primary' : 'text-mcgard-gray-900'
              ])
              }, _toDisplayString(item.iso), 3)
            ], 8, _hoisted_4)
          ]))
        }), 128))
      ])
    ], 2)
  ]))
}
}

})